module.exports = __webpack_public_path__ + "img/3ac64db.png";